let mainHost = 'http://lechat.lordar.com:8088/'
mainHost = 'http://' + window.location.host
var devConstGlobal = {
    MainHost: mainHost,

    HostSource: ' http://192.168.100.200:8888/',
    HostFileUpload: 'http://192.168.100.200:8888/apps/file/',

    // 权限管理
    // HostPrivilege: 'http://192.168.100.169:9810/privilege/',
    HostPrivilege: 'http://192.168.100.94:9810/privilege/',

    // 组织结构
    // HostContact: 'http://192.168.100.32:9810/orgContacts/',
    HostContact: 'http://192.168.100.94:9810/orgContacts/',

    HostDefaultImgUpload: 'http://firemanrecruitadmin.jieyundata.com:18124/fireRecruitCMS/upload',
    // 意见反馈
    // HostFeedback: 'http://admin.pubres.jieyundata.com:17030/adminPubRes/',
    HostFeedback: 'http://192.168.108.57:8211/adminPubRes/',
    // HostFeedback: 'http://weixin.ggzy.gov.cn/adminPubRes/',
    //
    HostCompany: 'http://192.168.108.57:8218/pubResDataPlatform/',
    Host: mainHost + '/apps/',
    pageSize: 8,
    ueditorDefault: 'static/js/ueditor1_4_3_3/'
}
export default devConstGlobal